import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { PaymentNote } from './PaymentNote';
import { PriceTag } from './PriceTag';
import { OfferCountdown } from './OfferCountdown';
import { images } from '../data/kit';
export function Hero() {
  return <header className="w-full bg-paper" data-id="element-164" data-mp="4m8msdv40tlg">
      <div className="border-b border-line bg-surface" data-id="element-165" data-mp="4na1csbc3y7x">
        <p className="mx-auto max-w-6xl px-5 py-3 text-center text-sm text-ink sm:text-base" data-id="element-166" data-mp="12a0mpfljy8wq">
          3 modelos explicados desde cero ·{' '}
          <span className="font-semibold" data-id="element-167" data-mp="xaxityhb68qc">Airbnb, Arbitraje y Productos Digitales</span>
        </p>
      </div>

      <div className="mx-auto grid max-w-6xl items-center gap-10 px-5 py-12 lg:grid-cols-[1.05fr_1fr] lg:gap-14 lg:py-16" data-id="element-168" data-mp="sde2mt11vlvr">
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="order-2 lg:order-1" data-id="element-169" data-mp="3d1imjfbj1mq2">
          <img src={images.hero} alt="Kit Ingresos Online: 3 volúmenes (Airbnb, Arbitraje, Productos Digitales) y bonos en tablet, celular y checklist" className="w-full rounded-3xl shadow-[0_30px_60px_-30px_rgba(18,26,21,0.35)]" data-id="element-170" data-mp="3j893p1w0vrk9" />
        </motion.div>

        <div className="order-1 lg:order-2" data-id="element-171" data-mp="3e8mqgsg72bbg">
          <p className="font-display text-lg font-black uppercase tracking-tight text-brand" data-id="element-172" data-mp="3ebipyl7ox820">Kit Ingresos Online</p>
          <h1 className="mt-3 font-display text-4xl font-black leading-[1.02] tracking-tight text-ink sm:text-5xl lg:text-[3.4rem]" data-id="element-173" data-mp="358rc6erce077">
            3 caminos reales para empezar a generar ingresos por Internet desde Argentina
          </h1>
          <p className="mt-5 font-display text-xl font-bold text-ink sm:text-2xl" data-id="element-174" data-mp="2vjzpom51w83o">
            <span className="text-airbnb" data-id="element-175" data-mp="2hinc2hdd4iky">Airbnb.</span> <span className="text-arbitraje" data-id="element-176" data-mp="2hjyp77sp72oq">Arbitraje.</span>{' '}
            <span className="text-digital" data-id="element-177" data-mp="2ll0i76w0uii9">Productos Digitales.</span>
          </p>
          <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-178" data-mp="s2jn3wuh80ji">
            Tres modelos completamente diferentes, explicados desde cero y paso a paso para que puedas elegir el que
            mejor encaje con vos y empezar a ejecutarlo.
          </p>
          <p className="mt-4 border-l-2 border-brand pl-4 text-base italic text-ink" data-id="element-179" data-mp="ici0zaloos78">
            Tus primeros USD 1.000 empiezan con una decisión: dejar de buscar ideas y empezar a ejecutar una.
          </p>

          <div className="mt-7 rounded-2xl bg-surface p-5 shadow-[0_1px_0_#e3ddce,0_12px_30px_-20px_rgba(18,26,21,0.25)] sm:p-6" data-id="element-180" data-mp="1ayjhtfeu9i6s">
            <p className="text-sm font-semibold text-ink" data-id="element-181" data-mp="1126owjr4b8d3">Acceso al KIT completo + 3 bonos exclusivos</p>
            <div className="mt-3" data-id="element-182" data-mp="x1nxurx1u6by">
              <PriceTag data-id="element-183" data-mp="x0l3ub4fjnrt" />
            </div>
            <p className="mt-1 text-sm text-muted" data-id="element-184" data-mp="3lsypkqaae6eu">Pago único · Acceso digital inmediato</p>
            <div className="mt-4" data-id="element-185" data-mp="3hrd7mqiwb1xs">
              <OfferCountdown data-id="element-186" data-mp="3hr3ptq808136" />
            </div>
            <div className="mt-5" data-id="element-187" data-mp="3htg5txu7c1dl">
              <CtaButton label="Quiero acceder al kit" fullWidth data-id="element-188" data-mp="1x9ukg9uwtbmw" />
            </div>
            <div className="mt-4" data-id="element-189" data-mp="21amx7d2zpynx">
              <PaymentNote data-id="element-190" data-mp="21bxx31tbem9r" />
            </div>
          </div>
        </div>
      </div>
    </header>;
}